import {CmsReactComponent} from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition,
} from "app/library/layout-builder";
import {VenueDetailProps} from "./types";
import {VenueDetailPropertyDefinitions} from 'components/cms/definitions';

export class VenueDetailDefinitions extends CmsReactComponent<VenueDetailProps> {
    static defaultProps = {};

    static schemaName = "venue-detail";

    static propertyDefinitions: PropertyDefinition[] = VenueDetailPropertyDefinitions;
}
